'use client';

import { useSiftScience } from '@zg-rentals/sift-science';

import { useCurrentUser } from '@/src/lib/hooks/query';

export function SiftScienceTracker() {
  const { data: user } = useCurrentUser();
  // hotpads-api exposes no impersonator flag; legacy hotpads-web made the same trade-off.
  useSiftScience({ email: user?.loggedIn ? user.data.email : null, isImpersonator: false });
  return null;
}
